import { Button } from '@/components/ui/button'

interface FilterPanelActionsProps {
  onClear: () => void
  onApply: () => void
}

export function FilterPanelActions({ onClear, onApply }: FilterPanelActionsProps) {
  return (
    <div className="flex gap-3">
      <Button
        type="button"
        className="flex-1 bg-gray-200 text-gray-800 hover:bg-gray-300"
        onClick={onClear}
      >
        Limpar Filtros
      </Button>
      <Button
        type="button"
        className="flex-1 bg-black text-white hover:bg-gray-800"
        onClick={onApply}
      >
        Aplicar
      </Button>
    </div>
  )
}
